import { Component, ViewChild } from '@angular/core';
import { CustomTableComponent, CustomTitle, DataColumnType, DEFAULT_DATE_FORMAT, ICustomTable, ISettings } from 'lib-base';
import { DialogModule } from 'primeng/dialog';
import { IGetConfiguracionActividadesHistorico } from '../../../../../../shared/interfaces/database/pqrsd';
import { firstValueFrom, forkJoin } from 'rxjs';
import { HistoricoEventoService } from '../../../../../../services/database/historico-evento.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-pqrds-config-act-historico',
  standalone: true,
  imports: [DialogModule, CustomTitle, CustomTableComponent],
  providers: [DatePipe],
  templateUrl: './pqrds-config-act-historico.component.html',
  styleUrl: './pqrds-config-act-historico.component.scss'
})
export class PqrdsConfigActividadHistoricoComponent {
  title: string = 'PQRSDF Actividad Historial';
  displayModal: boolean = false;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  readonly defaultDateFormat = DEFAULT_DATE_FORMAT;

  constructor(private readonly _hes: HistoricoEventoService, private readonly _t: TranslateService, private readonly datePipe: DatePipe) { }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      actividades: this._t.get('common.actividades'),
      actividad: this._t.get('common.actividad'),
      tipo: this._t.get('common.tipo'),
      orden: this._t.get('common.orden'),
      plazoFechaCierre: this._t.get('common.plazoFechaCierre'),
      requiereRolSeguridad: this._t.get('msg.requiere-rol-seguridad'),
      limpiar: this._t.get('form.button.limpiar'),
      guardar: this._t.get('form.button.guardar'),
      cancelar: this._t.get('form.button.cancelar'),
      nuevaActividad: this._t.get('msg.nuevaActividad'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
      actividadesGuardadas: this._t.get('msg.actividadesGuardadas'),
      usuarioEvento: this._t.get('common.usuarioEvento'),
      evento: this._t.get('common.evento'),
      fechaActualizacion: this._t.get('common.fechaActualizacion'),
    }));
    this.configColumns();
  }

  private configColumns() {
    this.customTable = {
      settings: {
        groupRows: {
          by: "cambioId",
          getHeaderValue: (data: any) => this.getHeaderValue(data)
        }
      } as ISettings,
      columns: [
        {
          field: 'actividad',
          header: this.trans.actividad,
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'orden',
          header: this.trans.orden,
          sort: true,
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'plazoFechaCierre',
          header: this.trans.plazoFechaCierre,
          sort: true,
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'usuarioEvento',
          header: this.trans.usuarioEvento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'evento',
          header: this.trans.evento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualizacion,
          width: '5rem',
          dataType: DataColumnType.DATE
        },
      ],
    } as ICustomTable;

  }

  getHeaderValue(data: IGetConfiguracionActividadesHistorico) {
    return "Fecha Actualizacion: " + this.datePipe.transform(data.fechaActualizacion, this.defaultDateFormat);
  }

  show(tipoTramiteId: number) {
    this.displayModal = true;
    this.loadHistorial(tipoTramiteId);
  }

  hide() {
    this.displayModal = false;
  }

  loadHistorial(tipoTramiteId: number) {
    this._hes.getConfiguracionActividadesHistorico(tipoTramiteId).subscribe({
      next: (data: IGetConfiguracionActividadesHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }
}
